import "react-datepicker/dist/react-datepicker.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import IconButton from "components/common/IconButton";
import React, { useEffect, useState, useRef } from "react";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import AdvanceTableFooter from "components/common/advance-table/AdvanceTableFooter";
import AdvanceTableWrapper from "components/common/advance-table/AdvanceTableWrapper";
//import { startProcess } from "components/workflow/VerifyEmailWorkflow";
import { useNavigate, useLocation } from "react-router-dom";
import { parse } from "date-fns";
import { getPendingTasks, claimTask, getCountTaskByAssignee, getCountWorkflowsByGroups, getCountWorkflowsByUsers } from "./WorkflowHelper";
import * as Constants from "common/constants";
import { useTranslation } from "react-i18next";
import * as em from "common/ErrorMessages";
import { EncryptStorage } from "encrypt-storage";
import { toast } from "react-toastify";
import { refreshWorkflowCounts } from "./WorkflowHelper";
import store from "reducers/store";
import LoaderIcon from "components/custom/Preloader";
import UpliftCss from "../common/upliftcss.module.css";
import SearchPanel from "components/common/SearchPanel";
import BreadCrums from "components/pages/landing/BreadCrums";
import PageTitle from "components/common/PageTitle";

function GetWorkflowListByCandidateGroup() {
	const encryptStorage1 = new EncryptStorage("secret-key-value", {
		prefix: "@mwan",
	});
	const navigate = useNavigate();

	const [fetchFlag, setFetchFlag] = useState(false);
	const [isRTL, setIsRTL] = useState(JSON.parse(localStorage.getItem("isRTL")) || false);
	const [isFinish, setIsFinish] = useState(false);

	const [workflows, setWorkflows] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [originalData, setOriginalData] = useState([]);
	const [totalCount, setTotalCount] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [sortField, setSortField] = useState("created");
	const [sortDirection, setSortDirection] = useState("desc");
	const [isLoading, setIsLoading] = useState(false);
	const [isDataReady, setIsDataReady] = useState(false);
	const lastCallParams = useRef(null);

	const [searchParams, setSearchParams] = useState({
		searchTerm: "",
		startDate: "",
		endDate: "",
	});

	const [searchValues, setSearchValues] = useState({
		searchTerm: "",
		startDate: null,
		endDate: null,
	});
	const [t, i18n] = useTranslation();
	const location = useLocation();
	const menuName = location?.state?.pagename || em.unassigne_task;
	// add table headers and accessor is the name of the field in the json
	const columns = [
		{
			Header: t("Process ID"),
			accessor: "generatedEmanifestID",
			sortable: true,
		},
		{
			Header: t("Process Name"),
			accessor: "name",
			sortable: true,
		},
		{
			Header: t("User Task Name"),
			accessor: "taskName",
			sortable: true,
		},
		{
			Header: t("Creation Date"),
			accessor: "created",
			sortable: true,
		},
		{
			Header: t("Action"),
			accessor: "action",
			sortable: false,
			disableSortBy: true,
		},
	];

	useEffect(() => {
		async function fetchData() {
			if (isLoading) return; // Prevent duplicate calls

			// Check if the same parameters were called recently
			const currentParams = { sortField, sortDirection, currentPage, pageSize, searchParams };
			const paramsString = JSON.stringify(currentParams);

			if (lastCallParams.current === paramsString) {
				return;
			}

			lastCallParams.current = paramsString;

			setIsLoading(true);
			setIsDataReady(false);
			setIsFinish(true);

			const userInfo = encryptStorage1.getItem(Constants.LoggedInUserInfoKeyInLocalStorage);
			const loggedInUser = userInfo.userId;
			const companyId = encryptStorage1.getItem(Constants.SelectedCompany);

			try {
				const response = await getPendingTasks(
					loggedInUser,
					null, // indexDbIds
					currentPage,
					pageSize,
					searchParams.searchTerm || "",
					searchParams.startDate || "",
					searchParams.endDate || "",
					sortField,
					sortDirection,
					true, // includeGroupWorkflows
					companyId // groupId
				);

				if (response && response.lPendingTaskResponseDTO) {
					const workflows = response.lPendingTaskResponseDTO.map((workflow, index) => ({
						...workflow,
						taskId: workflow.taskId,
						created: workflow.created || "",
						taskName: t(workflow.taskName || workflow.name),
						name: t(workflow.processDefinition?.name || workflow.name) + (workflow.processInformation ? t(workflow.processInformation) : ""),
						action: (
							<OverlayTrigger
								overlay={
									<Tooltip style={{ position: "fixed" }} id="idsubmit">
										{t(em.execute_task)}
									</Tooltip>
								}
							>
								<div className="theme-control-toggle-label icon-position">
									<IconButton
										className={`play-hover  ${UpliftCss.forceButtonColorwhite}`}
										iconClassName="fs--2"
										variant="falcon-default"
										size="sm"
										icon="fa fa-play"
										style={{
											margin: "auto 0.25rem",
											backgroundColor: "#00a862",
											borderColor: "#00a862",
										}}
										onClick={() => assignTask(workflow)}
									></IconButton>
								</div>
							</OverlayTrigger>
						),
						index: index,
					}));

					setTableData(workflows);
					setWorkflows(workflows);
					setTotalCount(response.totalCount || 0);

					if (!originalData || originalData.length === 0) {
						setOriginalData(workflows);
					}
				} else {
					setTableData([]);
					setWorkflows([]);
					setTotalCount(0);
				}
			} catch (error) {
				console.error("Error fetching workflows:", error);
				setTableData([]);
				setWorkflows([]);
				setTotalCount(0);
			} finally {
				setIsFinish(false);
				setIsLoading(false);
				setIsDataReady(true);
			}
		}
		fetchData();
	}, [fetchFlag, currentPage, pageSize, searchParams, sortField, sortDirection]);

	const assignTask = async (workflow) => {
		const userInfo = encryptStorage1.getItem(Constants.LoggedInUserInfoKeyInLocalStorage);
		const companyId = encryptStorage1.getItem(Constants.SelectedCompany);
		const loggedInUser = userInfo.userId;

		await claimTask(workflow.taskId, loggedInUser, true);

		// Refresh counts after claiming task
		await refreshWorkflowCounts();

		toast.success(t("Successfully Assigned"), {
			position: "top-right",
			autoClose: 3000,
		});
		navigate("/userTasks?generatedEmanifestId=" + workflow.generatedEmanifestID);
	};

	return (
		<>
			<div className="container">
				<PageTitle menuName={menuName} />
				{isFinish && <LoaderIcon />}
				<div className="row">
					<div className="col-12">
						{/* <h1>Workflow List</h1>*/}
						<div className={`card ${UpliftCss.BodyBorder}`}>
							<div className="">
								<div className={`mb-3 ${UpliftCss.tableHeader}`}>
									{isDataReady && (
										<AdvanceTableWrapper
											columns={columns}
											data={tableData}
											sortable={true}
											pagination={true}
											perPage={pageSize}
											onSort={(field, direction) => {
												// Only allow sorting by valid fields
												const validSortFields = ["generatedEmanifestID", "name", "taskName", "created"];
												if (!validSortFields.includes(field)) {
													return;
												}

												// Prevent unnecessary re-renders if the same sort is applied
												if (field !== sortField || direction !== sortDirection) {
													setSortField(field);
													setSortDirection(direction);
													setCurrentPage(1); // Reset to first page when sorting
													setIsDataReady(false);
												}
											}}
											initialSortBy={[{ id: sortField, desc: sortDirection === "desc" }]}
											defaultSortField="created"
											defaultSortDirection="desc"
										>
											<SearchPanel
												onSearch={(filters) => {
													setSearchParams(filters);
													setCurrentPage(1); // Reset to first page when searching
													setIsDataReady(false);
												}}
												searchValues={searchValues}
												setSearchValues={setSearchValues}
											/>
											<AdvanceTable
												table
												headerClassName="bg-200 text-900 text-nowrap align-middle"
												rowClassName="align-middle white-space-nowrap"
												tableProps={{
													bordered: true,
													striped: true,
													className: "fs--1 mb-0 overflow-hidden",
												}}
											/>
											<div className="mt-3">
												<AdvanceTableFooter
													rowCount={totalCount}
													pageSize={pageSize}
													pageIndex={currentPage - 1}
													page={tableData}
													setPageSize={(size) => {
														setPageSize(size);
														setCurrentPage(1);
														setIsDataReady(false);
													}}
													canPreviousPage={currentPage > 1}
													canNextPage={currentPage * pageSize < totalCount}
													nextPage={() => {
														if (currentPage * pageSize < totalCount) {
															setCurrentPage(currentPage + 1);
															setIsDataReady(false);
														}
													}}
													previousPage={() => {
														if (currentPage > 1) {
															setCurrentPage(currentPage - 1);
															setIsDataReady(false);
														}
													}}
													rowInfo
													navButtons
													rowsPerPageSelection
													rowsPerPageOptions={[5, 10, 15]}
													perPage={totalCount}
													jumpToPage={(page) => {
														setCurrentPage(page);
														setIsDataReady(false);
													}}
												/>
											</div>
										</AdvanceTableWrapper>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default GetWorkflowListByCandidateGroup;
